export const PhoneNumberSelector = 'phoneNumber';
